import ServerErrorInterface from '../../interfaces/server/Error'

import constants from '../../config/constants'

export default (error: ServerErrorInterface) => {
  const errorIsFieldErrorThatShouldBeShownGlobal =
    error.data &&
    error.data.fieldName &&
    constants.fieldErrorCodesThatShouldBeShownGlobally.includes(
      error.data.fieldName
    )

  const errorIsServerPanicError =
    (error.code === 'ERROR' || error.code === '[ERROR]') && error.message === ''

  const errorHasNoFieldName = Boolean(
    !error.data || (error.data && !error.data.fieldName)
  )

  return (
    errorIsFieldErrorThatShouldBeShownGlobal ||
    errorIsServerPanicError ||
    errorHasNoFieldName ||
    false
  )
}
